/* tslint:disable */
/* eslint-disable */
/**
 * LMS API
 * This is LMS API Documentation.
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { StripeSubscriptionItems } from './stripe-subscription-items';

/**
 * 
 * @export
 * @interface StripeSubscription
 */
export interface StripeSubscription {
    /**
     * 
     * @type {string}
     * @memberof StripeSubscription
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeSubscription
     */
    status?: StripeSubscriptionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof StripeSubscription
     */
    current_period_end?: number;
    /**
     * 
     * @type {number}
     * @memberof StripeSubscription
     */
    current_period_start?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StripeSubscription
     */
    cancel_at_period_end?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StripeSubscription
     */
    canceled_at?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StripeSubscription
     */
    customer?: string;
    /**
     * 
     * @type {StripeSubscriptionItems}
     * @memberof StripeSubscription
     */
    items?: StripeSubscriptionItems;
}

/**
    * @export
    * @enum {string}
    */
export enum StripeSubscriptionStatusEnum {
    Incomplete = 'incomplete',
    IncompleteExpired = 'incomplete_expired',
    Trialing = 'trialing',
    Active = 'active',
    PastDue = 'past_due',
    Canceled = 'canceled',
    Unpaid = 'unpaid'
}



